import type { TournamentResponse } from "../api/legacyTypes";
import { MatchCard } from "./MatchCard";

type Bracket = TournamentResponse["tournament"]["brackets"][number];

export function SwissSchedule({ bracket, wiki, tournamentId = "" }: { bracket?: Bracket; wiki: string; tournamentId?: string }) {
  if (!bracket?.rounds.length) return null;
  return (
    <div className="swiss-schedule" aria-label="Swiss group stage schedule">
      {bracket.rounds.map((round) => <section className="swiss-round" key={round.name}>
        <h3>{round.name}</h3>
        <div>{round.matches.map((match) => <MatchCard key={match.sourceKey} match={match} gameId={wiki} tournamentId={tournamentId} />)}</div>
      </section>)}
    </div>
  );
}
